module.exports = __webpack_public_path__ + "img/36_12.d0befcb9.png";